module.exports = __webpack_public_path__ + "img/s_1.e5da8f7b.png";